export default {
    notes: [],
    activeNote: null,
    noteHistory: [],
    totalNotes: 0,
    totalChanges: 0
}